/* eslint-disable react-hooks/exhaustive-deps */
import { QuestionCircleOutlined } from '@ant-design/icons';
import { Button, Tooltip } from 'antd';
import TimeLogsRulesModal from 'components/TimeLogs/TimeLogsRulesModal';
import { useNavigate } from 'react-router-dom';
import { CloseSvg } from 'utils/svgs';
import styles from './index.module.scss';
import UploadPreview from './UploadPreviewTable';
import { AppDispatch } from 'redux/store';
import { useDispatch, useSelector } from 'react-redux';
import { clearOcrData } from '../../redux/slices/OcrTimeLogsSlice';
import { useEffect, useState } from 'react';
import { invalidText } from 'utils/utils';

const UploadPreviewComponent = () => {
	const navigate = useNavigate();
	const { data } = useSelector((state: any) => state.ocrTimeLogs);
	const [supervisorName, setSupervisorName] = useState('');
	const [isTimeLogsRulesModalOpen, setIsTimeLogsRulesModalOpen] =
		useState(false);

	const dispatch = useDispatch<AppDispatch>();

	useEffect(() => {
		if (invalidText(data)) {
			navigate('/daily-attendance');
			return;
		}
		const res = data;

		setSupervisorName(res?.data?.supervisorName);
	}, []);

	return (
		<div className="modal-animation">
			<div className={styles['time-logs-preview']}>
				<div className={styles['time-logs-preview__header']}>
					<div
						className={styles['time-logs-preview__header__title-wrap']}
					>
						<div
							className={styles['time-logs-preview__header__title']}
						>
							Time Logs Preview{' '}
							{invalidText(supervisorName)
								? ''
								: `(${supervisorName})`}
						</div>
						<Tooltip title="How hours are calculated">
							<Button
								type="link"
								size="small"
								className={
									styles['time-logs-preview__header__rules-link']
								}
								icon={<QuestionCircleOutlined />}
								onClick={() => setIsTimeLogsRulesModalOpen(true)}
							>
								How hours work
							</Button>
						</Tooltip>
					</div>
					<div
						className={styles['time-logs-preview__header__actions']}
						onClick={() => {
							navigate('/daily-attendance');
							dispatch(clearOcrData());
						}}
					>
						<CloseSvg />
					</div>
				</div>
				<div className={styles['time-logs-preview__table']}>
					<UploadPreview />
				</div>
			</div>

			<TimeLogsRulesModal
				open={isTimeLogsRulesModalOpen}
				onClose={() => setIsTimeLogsRulesModalOpen(false)}
			/>
		</div>
	);
};

export default UploadPreviewComponent;
